<template>
  <div class="main Prodetails">
    <div class="nav">
      <div class="left">
        <div class="front icon_back" @click="rback()"></div>
        <span @click="rback()">返回商城</span>
      </div>
    </div>
    <div style="overflow: scroll">
      <div class="conter_banner" v-if="detaildec.imgShow">
        <van-swipe :autoplay="3000">
          <van-swipe-item
            v-for="(item, index) in detaildec.imgShow"
            :key="index"
          >
            <!-- <a :href="item.url" target="_blank"> -->
            <img :src="item" alt />
            <!-- </a> -->
          </van-swipe-item>
        </van-swipe>
        <div class="zkname" v-if="detaildec.is_discount_yn == 1">
          {{ detaildec.attribute_discount_json.title }}
        </div>
      </div>
      <div class="conter_details">
        <div class="discont">
          <p class="original_price" v-if="detaildec.is_discount_yn == 1">
            原价：{{ detaildec.priceInfo[0].amount }}
          </p>
          <div>
            <span
              class="discount"
              v-if="
                detaildec.is_discount_yn == 1 ||
                (detaildec.discount && detaildec.discount.discount)
              "
              >折后：{{ detaildec.discountPriceInfo[0].amount }}</span
            >
            <span
              class="vip_title"
              v-if="
                detaildec.is_discount_yn == 2 &&
                detaildec.discount &&
                detaildec.discount.discount
              "
              >会员特权折扣</span
            >
            <span
              class="vip_title"
              v-if="
                detaildec.is_discount_yn == 1 &&
                detaildec.discount &&
                detaildec.discount.discount &&
                detaildec.discountPriceInfo
              "
              >会员折上折：{{ detaildec.discountPriceInfo[0].vipAmount }}</span
            >
          </div>
          <div class="time" v-if="redVisible == 1">
            <div class="time-bg">
              <span>距结束仅剩：</span><span>{{ hour }}</span> 时
              <span>{{ min }}</span> 分 <span>{{ sec }}</span> 秒
            </div>
            <div>{{ timerTotel }}</div>
          </div>
        </div>
        <div class="xt"></div>
        <div class="details_one">
          <div class="decs_box">
            <div class="decs_name">{{ detaildec.title }}</div>
            <div class="decs_pec" v-if="detaildec && detaildec.priceInfo">
              金币：<span>{{ detaildec.priceInfo[0].amount }}</span>
            </div>
          </div>
          <div class="num">
            <span class="sales"
              >已售出：{{ detaildec.sales + detaildec.real_sales }}</span
            ><span class="stock">库存：{{ detaildec.limit_stock }}</span>
          </div>
        </div>
        <div class="xt"></div>
        <div class="details_two">
          <div v-html="textW"></div>
        </div>
      </div>
    </div>
    <div class="btn-pec">
      <div class="btn-flex">
        <div class="box">
          <div @click="subtract()">
            <img class="less" src="../assets/images/Less.png" alt="" />
          </div>
          <div>
            <input
              type="text"
              value="0"
              readonly="true"
              size="1"
              v-model="count"
            />
          </div>
          <div @click="subadd()">
            <img class="puls" src="../assets/images/plus.png" alt="" />
          </div>
        </div>
        <div
          class="btn_color"
          :class="[
            this.count > detaildec.limit_stock || detaildec.limit_stock == 0
              ? 'class_b'
              : 'class_a',
          ]"
          @click="goodsby(detaildec)"
        >
          立即购买
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  data() {
    return {
      detaildec: {},
      textW: "",
      count: "1",
      statusId: "",
      isActive: false,
      timetemp: 0,
      hour: "",
      min: "",
      sec: "",
      redVisible: 1,
    };
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapState("homePage", ["Syssetting"]),
    // 转换成时分秒a
    timerTotel() {
      let time = this.timetemp;
      console.log(time);
      // console.log(time)
      // if (time == 0) {
      //   return (this.redVisible = 1);
      // }
      let d = Math.floor(time / (24 * 60 * 60));
      let allHours = d * 24;
      let h = Math.floor((time % (24 * 60 * 60)) / 3600);
      h += allHours;
      let m = Math.floor(((time % (60 * 60 * 24)) % 3600) / 60);
      let s = Math.floor(((time % (60 * 60 * 24)) % 3600) % 60);
      // d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;

      // return
      // this.day = d;
      this.hour = h;
      this.min = m;
      this.sec = s;
      // return `${d} 天 ${h} 小时 ${m} 分钟 ${s} 秒`
    },
  },
  methods: {
    rback() {
      let query = {
        userId: this.queryData.userId,
        uid: this.queryData.uid,
        TopHeight: this.queryData.TopHeight,
        apptype: this.queryData.apptype,
        appId: this.queryData.appId,
      };
      if (this.queryData.isRn == "1") {
        query.isRn = "1";
      }
      this.$router.push({
        path: "/",
        query,
      });
    },
    subadd() {
      if (this.detaildec.is_purchase_limit == 1) {
        Toast("限购商品，数量不能再增加啦");
      } else {
        this.count++;
      }
    },
    subtract() {
      if (this.count <= 1) {
        Toast("受不了啦，物品不能再减少啦");
        // this.count=0;
      } else {
        this.count -= 1;
      }
    },
    // huojiang(detaildec) {
    //   if (this.count > detaildec.limit_stock || detaildec.limit_stock == 0) {
    //     return false;
    //   }
    //   if (!this.queryData.addresssId) {
    //     this.$dialog
    //       .confirm({
    //         title: "兑换提醒",
    //         message: "此物品需要选择收货地址",
    //       })
    //       .then(() => {
    //         let obj = {
    //           userId: this.queryData.userId,
    //           appId: this.queryData.appId,
    //           uid: this.queryData.uid,
    //           TopHeight: this.queryData.TopHeight,
    //           apptype: this.queryData.apptype,
    //         };
    //         this.$router.push({
    //           path: "/addCheck",
    //           query: obj,
    //         });
    //       });
    //   } else {
    //     let obj = {
    //       goodsId: detaildec.id,
    //       userId: this.queryData.userId,
    //       appId: this.queryData.appId,
    //       addresssId: this.queryData.addresssId,
    //       uid: this.queryData.uid,
    //       goods_num: this.count,
    //     };
    //     let data = detaildec.priceInfo;
    //     for (let k in data) {
    //       data[k];
    //       this.$dialog
    //         .confirm({
    //           title: "兑换提醒",
    //           message:
    //             "确定使用" +
    //             data[k].amount +
    //             "金币兑换 " +
    //             detaildec.title +
    //             " 吗？",
    //         })
    //         .then(() => {
    //           this.$store
    //             .dispatch("homePage/fetchGoodsExchange", obj)
    //             .then((res) => {
    //               // console.log(res.data.unprice.id)
    //               if (res.code == 200) {
    //                 this.$dialog({
    //                   title: "兑换提醒",
    //                   message: "兑换奖品成功",
    //                 }).then(() => {
    //                   this.sensors.track(
    //                     "ExchangeCommodity",
    //                     {
    //                       // app_number: `${this.queryData.apptype} + _ + ${this.queryData.uid}`,
    //                       app_number: this.queryData.apptype,
    //                       mall_commodity_id: res.data.unprice.id,
    //                     },
    //                     () => {
    //                       console.log("success");
    //                     }
    //                   );
    //                   if (window && window.AndroidClient) {
    //                     let params = {
    //                       amount: res.data.unprice.amount,
    //                       mall_commodity_id: res.data.unprice.id,
    //                     };
    //                     window.AndroidClient.callBackAfterFinishOrder(
    //                       JSON.stringify(params)
    //                     );
    //                   }
    //                   if (
    //                     window &&
    //                     window.webkit &&
    //                     window.webkit.messageHandlers
    //                   ) {
    //                     let params = {
    //                       amount: res.data.unprice.amount, //商品消耗金币
    //                       mall_commodity_id: res.data.unprice.id, //商品id
    //                     };
    //                     window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
    //                       params
    //                     );
    //                   }
    //                 });
    //                 this.$router.push({
    //                   path: "/",
    //                   // name: "Prodetails",
    //                   query: this.queryData,
    //                 });
    //               } else {
    //                 Toast({
    //                   message: res.msg,
    //                 });
    //               }
    //             });
    //         });
    //     }
    //   }
    // },
    //提现注释
    // deliverGoods(detaildec) {
    //   if (this.count > detaildec.limit_stock || detaildec.limit_stock == 0) {
    //     return false;
    //   }
    //   // if(this.statusId == 1){
    //   // console.log(this.queryData.alipayId);
    //   if (!this.queryData.bankId && !this.queryData.alipayId) {
    //     this.$dialog
    //       .confirm({
    //         title: "兑换提醒",
    //         message: "此物品需要选择提现信息",
    //       })
    //       .then(() => {
    //         let obj = {
    //           userId: this.queryData.userId,
    //           appId: this.queryData.appId,
    //           uid: this.queryData.uid,
    //           TopHeight: this.queryData.TopHeight,
    //           apptype: this.queryData.apptype,
    //         };
    //         this.$router.push({
    //           path: "/bankCheck",
    //           query: obj,
    //         });
    //       });
    //   } else {
    //     let obj = {
    //       goodsId: detaildec.id,
    //       userId: this.queryData.userId,
    //       appId: this.queryData.appId,
    //       bankId: this.queryData.bankId,
    //       alipayId: this.queryData.alipayId,
    //       uid: this.queryData.uid,
    //       goods_num: this.count,
    //     };
    //     let data = detaildec.priceInfo;
    //     for (let k in data) {
    //       data[k];
    //       this.$dialog
    //         .confirm({
    //           title: "兑换提醒",
    //           message:
    //             "确定使用" +
    //             data[k].amount +
    //             "金币兑换 " +
    //             detaildec.title +
    //             " 吗？",
    //         })
    //         .then(() => {
    //           this.$store
    //             .dispatch("homePage/fetchGoodsExchange", obj)
    //             .then((res) => {
    //               if (res.code == 200) {
    //                 this.$dialog({
    //                   title: "兑换提醒",
    //                   message: "折现奖品成功",
    //                 }).then(() => {
    //                   this.sensors.track(
    //                     "ExchangeCommodity",
    //                     {
    //                       app_number: this.queryData.apptype,
    //                       mall_commodity_id: res.data.unprice.id,
    //                     },
    //                     () => {
    //                       console.log("success");
    //                     }
    //                   );
    //                   if (window && window.AndroidClient) {
    //                     let params = {
    //                       amount: res.data.unprice.amount,
    //                       mall_commodity_id: res.data.unprice.id,
    //                     };
    //                     window.AndroidClient.callBackAfterFinishOrder(
    //                       JSON.stringify(params)
    //                     );
    //                   }
    //                   if (
    //                     window &&
    //                     window.webkit &&
    //                     window.webkit.messageHandlers
    //                   ) {
    //                     let params = {
    //                       amount: res.data.unprice.amount, //商品消耗金币
    //                       mall_commodity_id: res.data.unprice.id, //商品id
    //                     };
    //                     window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
    //                       params
    //                     );
    //                   }

    //                   //  console.log('jsidfjidji')
    //                   this.$router.push({
    //                     path: "/",
    //                     // name: "Prodetails",
    //                     query: this.queryData,
    //                   });
    //                 });
    //                 // this.$store.dispatch("homePage/fetchHome", obj);
    //                 // this.$store.dispatch("homePage/fetchProductList", obj);
    //                 // let jx = {
    //                 //   userId: this.queryData.userId,
    //                 //   appId: this.queryData.appId,
    //                 //   uid: this.queryData.uid,
    //                 //   is_chosen: 1,
    //                 //   pageSize: 999,
    //                 // };
    //                 // this.$store.dispatch("homePage/fetchChosenList", jx);
    //               } else {
    //                 Toast({
    //                   message: res.msg,
    //                 });
    //               }
    //             });
    //         });
    //     }
    //   }
    //   // }
    // },
    goodsby(detaildec) {
      if (this.count > detaildec.limit_stock || detaildec.limit_stock == 0) {
        return false;
      }
      //   this.detailMask = false;
      if (detaildec.exchange_type == 1) {
        let obj = {
          goodsId: detaildec.id,
          userId: this.queryData.userId,
          appId: this.queryData.appId,
          uid: this.queryData.uid,
          goods_num: this.count,
        };
        if (detaildec.is_discount_yn == 1) {
          // console.log(1)
          let data = detaildec.discountPriceInfo[0];
          let qq = data.vipAmount ? data.vipAmount : data.amount;
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" + qq + "金币兑换 " + detaildec.title + " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      // name: "Prodetails",
                      query: this.queryData,
                    });
                  } else {
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        } else {
          let data1 = detaildec.priceInfo[0];
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" +
                data1.amount +
                "金币兑换 " +
                detaildec.title +
                " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      // name: "Prodetails",
                      query: this.queryData,
                    });
                  } else {
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        }
      }
      if (detaildec.exchange_type == 2) {
        let obj = {
          userId: this.queryData.userId,
          uid: this.queryData.uid,
          TopHeight: this.queryData.TopHeight,
          apptype: this.queryData.apptype,
          goodsId: detaildec.id,
          appId: this.queryData.appId,
          // addresssId: this.queryData.addresssId,
          // bankId: this.queryData.bankId,
          // alipayId: this.queryData.alipayId,
        };
        this.$router.push({
          path: "/determineorder",
          name: "determineorder",
          query: obj,
          params: { allcount: this.count },
        });
        // let obj = {
        //   goods_num: this.count,
        //   userId: this.queryData.userId,
        //   appId: this.queryData.appId,
        //   uid: this.queryData.uid,
        //   TopHeight: this.queryData.TopHeight,
        //   apptype: this.queryData.apptype,
        // };
        // this.$store.dispatch("homePage/fetchAddressList", obj).then((res) => {
        //   if (JSON.stringify(res.data) == "{}") {
        //     this.$dialog
        //       .confirm({
        //         title: "添加地址提醒",
        //         message: "此物品需要添加地址",
        //       })
        //       .then(() => {
        //         this.$router.push({
        //           path: "/selfInfo",
        //           name: "selfInfo",
        //           query: obj,
        //           params: { statusTab: 1 },
        //         });
        //       });
        //   } else {
        //     this.huojiang(detaildec);
        //   }
        // });
      }
      // if (detaildec.exchange_type == 3) {
      //   let obj = {
      //     goods_num: this.count,
      //     userId: this.queryData.userId,
      //     appId: this.queryData.appId,
      //     uid: this.queryData.uid,
      //     TopHeight: this.queryData.TopHeight,
      //     apptype: this.queryData.apptype,
      //   };
      //   // console.log(this.homePage.bankList)
      //   // console.log(this.homePage.AlipayList)

      //   // this.$store.dispatch("homePage/fetchBankList", obj).then((res) => {
      //   //   console.log(res.data);
      //   if (
      //     JSON.stringify(this.homePage.bankList) === "{}" &&
      //     JSON.stringify(this.homePage.AlipayList) === "{}"
      //   ) {
      //     this.$dialog
      //       .confirm({
      //         title: "添加提现提醒",
      //         message: "此物品需要添加提现信息",
      //       })
      //       .then(() => {
      //         this.$router.push({
      //           path: "/selfInfo",
      //           name: "selfInfo",
      //           query: obj,
      //           params: { statusTab: 2 },
      //         });
      //       });
      //   } else {
      //     this.deliverGoods(detaildec);
      //   }
      //   // });
      // }
    },
    // 活动未开始 倒计时
    openTimer() {
      this.activeTimer = setInterval(() => {
        this.timetemp--;
        // console.log(this.timetemp--)
      }, 980);
    },
    numFilter(s) {
      let realVal = parseFloat(s).toFixed(2);
      return realVal;
    },
  },
  //   numFilter(s) {
  //   let realVal = parseFloat(s).toFixed(2);
  //   return realVal;
  // },
  filters: {
    numFilter(s) {
      let realVal = parseFloat(s).toFixed(2);
      return realVal;
    },
  },
  created() {
    this.queryData = this.$route.query || {};
    this.count = this.$route.params.acount
      ? this.$route.params.acount
      : this.count;
    let goods = {
      userId: this.queryData.userId,
      goodsId: this.queryData.goodsId,
      appId: this.queryData.appId,
    };
    this.$store.dispatch("homePage/fetchGoodsDetail", goods).then((res) => {
      this.detaildec = res;
      let selfDate = Date.parse(new Date());
      let start = Date.parse(
        this.detaildec.attribute_discount_json.etime.replace(/-/g, "/")
      );
      // let end = Date.parse(this.detaildec.attribute_discount_json.btime.replace(/-/g, "/"));
      if (start > selfDate) {
        this.redVisible = 1;
        this.timetemp = (start - selfDate) / 1000;
        this.openTimer();
      } else {
        this.redVisible = 2;
      }
      this.textW = res.details.replace(/\n/g, "<br>");
    });
    this.$store.dispatch("homePage/fetchSyssetting").then((res) => {
      this.statusId = res.data[1][0].value;
      console.log(this.statusId);
    });
  },
};
</script>

<style lang="scss" scoped>
.Prodetails {
  background: #fff;
  .conter_banner {
    position: relative;
    .zkname {
      position: absolute;
      color: #624118;
      font-size: 16px;
      border-radius: 2px;
      background: linear-gradient(139.13deg, #ffeac5 0%, #e9bd6c 100%);
      padding: 4px;
      bottom: 0;
    }
  }
  .nav {
    width: 100%;
    height: 44px;
    background: #fff;
    span {
      font-size: 18px;
      color: #222222;
      margin-left: 8px;
    }
  }
  .van-swipe {
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .conter_details {
    padding-bottom: 86px;
    // background: #fff;
    .discont {
      margin: 15px 0 0 12px;
    }
    .details_one {
      background: #fff;
      padding: 16px 12px;
      .decs_box {
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        .decs_name {
          width: 205px;
          font-size: 16px;
          color: #222222;
        }
        .decs_pec {
          font-size: 14px;
          color: #ff6c2a;
          span {
            font-size: 18px;
            color: #ff6c2a;
          }
        }
      }
    }
    .details_two {
      background: #fff;
      //   margin-top: 8px;
      padding: 12px;
      font-size: 14px;
      color: #676767;
      line-height: 20px;
    }
  }
  .btn-pec {
    width: 100%;
    height: 82px;
    background: #ffffff;
    box-shadow: 0 -2px 12px 0 #f0f0f5;
    position: fixed;
    bottom: 0;
    .btn-flex {
      margin-top: 15px;
      width: 100%;
      //   margin: 0 12px;
      display: flex;
      justify-content: space-around;
      .box {
        width: 148px;
        height: 44px;
        border: 1px solid #dbdbdb;
        border-radius: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // font-size: 28px;
        div {
          width: 49px;
          //   height: 44px;
          //   line-height: 44px;
          //   font-size: 28px;
          text-align: center;
        }
        input {
          font-size: 22px;
          padding: 0;
          width: 49px;
          border: none;
          background: none;
          text-align: center;
        }
      }
    }
    .btn_color {
      //   background-image: linear-gradient(246deg, #fe7700 14%, #fe560a 88%);
      border-radius: 24px;
      width: 188px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }
    .class_a {
      background-image: linear-gradient(246deg, #fe7700 14%, #fe560a 88%);
    }
    .class_b {
      background: #bfbfbf;
    }
  }
  .xt {
    height: 8px;
    width: 100%;
    background: #f0f0f5;
  }
  //   .van-swipe-item{
  //       width: 375px;
  //   }
  .num {
    .sales {
      font-size: 12px;
      color: #222222;
    }
    .stock {
      margin-left: 30px;
      font-size: 12px;
      color: #a6a6a6;
    }
  }
  .less {
    width: 12px;
    height: 12px;
  }
  .puls {
    width: 12px;
    height: 12px;
  }
  .original_price {
    color: #a6a6a6;
    font-size: 12px;
    text-decoration: line-through;
    margin-bottom: 2px;
  }
  .discount {
    margin-right: 5px;
    border-radius: 2px;
    background: linear-gradient(103.53deg, #e86463 0%, #ea3d3c 100%);
    color: #ffffff;
    font-size: 12px;
    padding: 4px;
  }
  .vip_title {
    border-radius: 2px;
    background: #1e1e1e;
    color: #ddb87a;
    font-size: 12px;
    padding: 4px;
    margin: 2px 0 10px 0;
  }
  .time {
    display: flex;
    margin: 15px 0;
    align-items: center;
    // div:nth-child(1) {
    //   color: #624118;
    //   font-weight: regular;
    //   font-size: 14px;
    // }
    p {
      color: #624118;
      font-size: 12px;
    }
    .time-bg {
      font-size: 12px;
      color: #624118;
      border-radius: 2px;
      background: #ddb87a;
      height: 28px;
      line-height: 28px;
      padding: 2px 4px;
    }
    span {
      height: 20px;
      line-height: 20px;
      border-radius: 2px;
      background: #fffbe6;
      padding: 0 3px;
      color: #624118;
      font-size: 14px;
      text-align: center;
      display: inline-block;
    }
    span:nth-child(1) {
      background: none;
    }
  }
}
</style>